// extracted by mini-css-extract-plugin
export default {"history":"History_history__SUMU2"};